import { useState, type FormEvent } from "react";
import { Logo } from "../components/Layout";
import { ApiError, getSession, login } from "../services/api";
import { useCatalog } from "../state/CatalogContext";

export function LoginPage() {
  const { setSession } = useCatalog();
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(password);
      setSession(await getSession());
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "No se pudo iniciar sesión.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="beam grid min-h-screen place-items-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm">
        <Logo />
        <h1 className="mt-10 font-display text-4xl">Hola de nuevo</h1>
        <p className="mt-2 text-muted">Escribe la contraseña de tu Radiant TV.</p>
        <label htmlFor="pw" className="mt-8 block text-sm text-muted">Contraseña</label>
        <input
          id="pw" type="password" autoComplete="current-password" required value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-1 w-full rounded-lg border border-line bg-surface px-4 py-3 outline-none focus:border-accent"
        />
        {error && <p className="mt-3 text-sm text-accent-2" role="alert">{error}</p>}
        <button className="btn btn-primary mt-6 w-full justify-center py-3" disabled={busy}>{busy ? "Entrando…" : "Entrar"}</button>
      </form>
    </div>
  );
}
